module.exports = __webpack_public_path__ + "img/fun6.bfa4f244.png";